var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "43px",
    height: "43px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b4363",
    d: "M 36.5,2.5 C 37.1174,2.61071 37.6174,2.94404 38,3.5C 38.8045,6.69646 38.6378,9.69646 37.5,12.5C 35.1985,13.8598 33.5318,13.1932 32.5,10.5C 30.0623,11.9308 28.3956,13.9308 27.5,16.5C 25.5454,17.3235 23.5454,17.4901 21.5,17C 20.2107,15.1978 18.5441,14.0312 16.5,13.5C 14.1838,14.8056 11.8505,16.1389 9.5,17.5C 8.5,17.5 7.5,17.5 6.5,17.5C 6.5,16.5 6.5,15.5 6.5,14.5C 9.20848,11.7915 12.2085,9.45815 15.5,7.5C 16.391,8.10978 17.391,8.44312 18.5,8.5C 19.5,8.83333 20.1667,9.5 20.5,10.5C 21.0516,12.7029 22.3849,13.5362 24.5,13C 26.3513,11.3163 28.018,9.48292 29.5,7.5C 27.5245,6.25074 27.1912,4.75074 28.5,3C 31.146,2.50258 33.8127,2.33591 36.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.153
    },
    fill: "#aaaebc",
    d: "M 15.5,7.5 C 16.779,6.28485 17.779,6.61818 18.5,8.5C 17.391,8.44312 16.391,8.10978 15.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.604
    },
    fill: "#969aab",
    d: "M 36.5,2.5 C 33.8127,2.33591 31.146,2.50258 28.5,3C 27.1912,4.75074 27.5245,6.25074 29.5,7.5C 28.018,9.48292 26.3513,11.3163 24.5,13C 22.3849,13.5362 21.0516,12.7029 20.5,10.5C 23.5214,12.0028 25.8547,11.1694 27.5,8C 24.8333,6 24.8333,4 27.5,2C 30.6965,1.19549 33.6965,1.36216 36.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.18
    },
    fill: "#b0b3c0",
    d: "M 37.5,12.5 C 35.9229,15.0168 34.0896,15.0168 32,12.5C 30.6288,14.0414 29.1288,15.3747 27.5,16.5C 28.3956,13.9308 30.0623,11.9308 32.5,10.5C 33.5318,13.1932 35.1985,13.8598 37.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e8499",
    d: "M 6.5,14.5 C 6.5,15.5 6.5,16.5 6.5,17.5C 7.5,17.5 8.5,17.5 9.5,17.5C 7.58007,18.9405 5.9134,18.6071 4.5,16.5C 4.85549,15.4777 5.52216,14.811 6.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9da1b1",
    d: "M 16.5,13.5 C 18.5441,14.0312 20.2107,15.1978 21.5,17C 23.5454,17.4901 25.5454,17.3235 27.5,16.5C 25.8233,19.7772 23.4899,20.2772 20.5,18C 18.9586,16.6288 17.6253,15.1288 16.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48
    },
    fill: "#878da1",
    d: "M 39.5,22.5 C 39.5,22.8333 39.5,23.1667 39.5,23.5C 38.7109,23.2172 38.0442,22.7172 37.5,22C 26.1206,21.2103 14.7872,21.377 3.5,22.5C 8.9597,21.1709 14.793,20.5042 21,20.5C 26.8333,20.6667 32.6667,20.8333 38.5,21C 39.056,21.3826 39.3893,21.8826 39.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#363d5e",
    d: "M 39.5,23.5 C 39.5,27.5 39.5,31.5 39.5,35.5C 39.67,36.8221 39.3366,37.9887 38.5,39C 27.1479,40.6439 15.8146,40.6439 4.5,39C 4,38.5 3.5,38 3,37.5C 2.18368,32.3158 2.35034,27.3158 3.5,22.5C 14.7872,21.377 26.1206,21.2103 37.5,22C 38.0442,22.7172 38.7109,23.2172 39.5,23.5 Z M 7.5,24.5 C 8.49162,24.3284 9.15829,24.6618 9.5,25.5C 8.07546,27.0311 7.40879,26.6977 7.5,24.5 Z M 23.5,26.5 C 25.6044,28.5832 25.9377,30.9165 24.5,33.5C 21.9967,34.7651 19.6634,34.4318 17.5,32.5C 17.5,31.1667 17.5,29.8333 17.5,28.5C 19.1417,26.9192 21.1417,26.2525 23.5,26.5 Z M 34.5,33.5 C 35.0431,33.56 35.3764,33.8933 35.5,34.5C 34.7435,35.7733 34.0768,35.7733 33.5,34.5C 34.1667,34.5 34.5,34.1667 34.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.037
    },
    fill: "#d9dae1",
    d: "M 39.5,22.5 C 40.9931,23.3121 41.6598,24.6455 41.5,26.5C 41.1402,29.7021 40.4735,32.7021 39.5,35.5C 39.5,31.5 39.5,27.5 39.5,23.5C 39.5,23.1667 39.5,22.8333 39.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.114
    },
    fill: "#b9bdc8",
    d: "M 23.5,26.5 C 21.1417,26.2525 19.1417,26.9192 17.5,28.5C 17.4142,27.5041 17.7476,26.6708 18.5,26C 20.3869,25.2204 22.0536,25.3871 23.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.306
    },
    fill: "#aaaebb",
    d: "M 35.5,24.5 C 36.7759,25.3864 36.7759,26.3864 35.5,27.5C 34.8933,27.3764 34.56,27.0431 34.5,26.5C 35.3382,26.1583 35.6716,25.4916 35.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.663
    },
    fill: "#72788f",
    d: "M 7.5,24.5 C 7.40879,26.6977 8.07546,27.0311 9.5,25.5C 9.30592,27.9118 7.97259,28.9118 5.5,28.5C 5.15684,26.5168 5.82351,25.1834 7.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.094
    },
    fill: "#9ba0b0",
    d: "M 6.5,35.5 C 5.59603,34.791 5.26269,33.791 5.5,32.5C 8.5,32.1667 9.83333,33.5 9.5,36.5C 8.20895,36.7373 7.20895,36.404 6.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.733
    },
    fill: "#6c728b",
    d: "M 17.5,32.5 C 19.6634,34.4318 21.9967,34.7651 24.5,33.5C 22.9894,35.4411 20.9894,35.9411 18.5,35C 17.7476,34.3292 17.4142,33.4959 17.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.298
    },
    fill: "#80869b",
    d: "M 34.5,33.5 C 34.56,32.9569 34.8933,32.6236 35.5,32.5C 36.4287,33.6888 36.762,35.0222 36.5,36.5C 35.0222,36.762 33.6888,36.4287 32.5,35.5C 32.6236,34.8933 32.9569,34.56 33.5,34.5C 34.0768,35.7733 34.7435,35.7733 35.5,34.5C 35.3764,33.8933 35.0431,33.56 34.5,33.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.4e303163a5b62b980a4c59d65eb57bd4.svg";
export { ForwardRef as ReactComponent };